import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  constructor(public translate:TranslateService) { }
  selectedLang;
  currentSelectedlang;
  languages = [{
    id: 1,
    name: 'English',
    code:'en',
  },
  {
    id: 2,
    name:'Korean',
    code:'ko',
  },
  {
    id: 3,
    name:'Swedish',
    code:'sv',
  },
{
    id: 4,
    name:'German',
    code:'de',
  },
{
    id: 4,
    name:'Japanese',
    code:'ja',
  }];

  setDefaultlang(){
    this.translate.addLangs(['en', 'ko','sv','de','ja']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/en |ko/) ? browserLang : 'en');
    this.selectedLang = this.languages[0];
    this.translate.use(this.selectedLang.code);
    this.translate.setDefaultLang(this.languages[0].code)
    this.currentSelectedlang=this.languages[0]
  }

  setSelectedlanguage(code) {
    for (let i = 0; i < this.languages.length; i++) {
      if (code === this.languages[i].code) {
        this.selectedLang = this.languages[i];
        this.translate.use(this.selectedLang.code);
        this.currentSelectedlang=this.languages[i]
        break;
      }
    }
  }
}
